<template>
  <div class="white_glove">
    <div style="margin:10px;">
      <v-row>
        <v-col cols="12">
          <v-card height="350px" elevation="12">
            <v-card-title style="position: relative;">
              <v-row>
                <v-col cols="6">White Glove Open Orders</v-col>
                <v-col cols="6"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedOpenWhiteGloveSearch($event)" style="width:250px;float:right"></v-text-field></v-col>
              </v-row>

              <v-row class="stage-filter-row" no-gutters>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stageFilter" class="custom-checkbox" label="1" :value="1" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stageFilter" class="custom-checkbox" label="2" :value="2" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stageFilter" class="custom-checkbox" label="3" :value="3" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stageFilter" class="custom-checkbox" label="4" :value="4" color="#ff7214" hide-details="true" density="compact" />
                </v-col>
                <v-col cols="auto">
                  <v-checkbox v-model="$store.state.stageFilter" class="custom-checkbox" label="Unstaged" :value="false" color="#ff7214" hide-details="true" density="compact" />
                </v-col>                                     
              </v-row>  
            
            </v-card-title>

            <v-card-text>
              <Vue3EasyDataTable
                :headers="open_white_glove_headers"
                :items="sales_order_data.open"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="245"
                :search-value="searchOpenWhiteGlove"
              >

                <template #item-stage="item">
                  <div style="width:75px;padding:4px">
                    <v-select
                      :items="item.stage === false ? [1,2,3,4] : [1,2,3,4,'unstage']"
                      label=""
                      :model-value="item.stage === false ? null : item.stage"
                      variant="outlined"
                      density="compact"
                      hide-details="auto"
                      @update:modelValue="(value) => updateStage(item.db_key, value)"
                    ></v-select>      
                  </div>
                </template>

                <template #item-sales_order_number="item">
                  <span class="dashboard-link" @click="openSalesOrderDetailPopup(item.sales_order_number)">
                    {{ item.sales_order_number }}
                  </span>
                  <div v-if="item.white_glove_support_order" class="white-glove-label">
                    WHITE GLOVE ORDER
                  </div>
                  <div v-if="item.white_glove_tracking_for_this_ship_to" class="white-glove-label light">
                    WHITE GLOVE ADDRESS
                  </div>
                </template>

                <template #item-order_date_sortable="item">
                  {{ item.order_date_formatted }}
                </template>

                <template #item-internal_notes="item">
                  <div
                    v-for="n in item.internal_notes"
                    style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;width:200px"
                  >
                    <div style="font-style:italic">{{ n.note }}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">
                      submitted {{ formatDate(n.submitted_date) }} by {{ n.submitted_by_name }}
                    </div>
                  </div>
                </template>
              </Vue3EasyDataTable>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12">
          <v-card height="350px" elevation="12">

            <v-card-title>
              <v-row>
                <v-col col="6">Recently Completed White Glove Orders (completed in the last 7 days)</v-col>
                <v-col col="6"><v-text-field label="Search..." variant="solo" density="compact" hide-details="true" @input="debouncedCompletedWhiteGloveSearch($event)" style="width:250px;float:right"></v-text-field></v-col>
              </v-row>
            </v-card-title>

            <v-card-text>
              <Vue3EasyDataTable
                :headers="recently_completed_white_glove_headers"
                :items="sales_order_data.recently_completed"
                :rows-per-page="2000"
                :hide-rows-per-page="true"
                :hide-footer="false"
                :table-height="245"
                :search-value="searchCompletedWhiteGlove"
              >
                <template #item-sales_order_number="item">
                  {{ item.sales_order_number }}
                <div v-if="item.white_glove_support_order" style="background: white;text-align: center;font-size:8px;line-height:150%;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;margin-bottom:2px">WHITE GLOVE ORDER</div>
                <div v-if="item.white_glove_tracking_for_this_ship_to" style="background: white;text-align: center;line-height:150%;font-size:8px;font-weight: bold;width:65px;border:1px solid black;border-radius: 4px;">WHITE GLOVE ADDRESS</div>
                </template>

                <template #item-order_date_sortable="item">
                  {{ item.order_date_formatted }}
                </template>

                <template #item-completed_date_sortable="item">
                  {{ item.completed_date_formatted }}
                </template>

                <template #item-internal_notes="item">
                  <div
                    v-for="n in item.internal_notes"
                    style="border-bottom:1px dashed gray;margin-top:5px;margin-bottom:5px;line-height:100%;width:200px"
                  >
                    <div style="font-style:italic">{{ n.note }}</div>
                    <div style="font-size:8px;line-height:100%;color:gray;">
                      submitted {{ formatDate(n.submitted_date) }} by {{ n.submitted_by_name }}
                    </div>
                  </div>
                </template>
              </Vue3EasyDataTable>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
  <PurchaseOrderDetailPopUp v-if="po_detail" :po="po_for_component" @close="closePurchaseOrderDetailPopup()" />
  <SalesOrderDetailPopUp v-if="sales_order_detail" :sales_order="sales_order_for_component" @close="closeSalesOrderDetailPopup()" />
</template>

<script>
import firebase from 'firebase/compat/app';
import { mapGetters } from 'vuex'
import Moment from 'moment-business-days'
import Vue3EasyDataTable from 'vue3-easy-data-table'
import PurchaseOrderDetailPopUp from '@/components/PurchaseOrderDetailPopUp.vue'
import SalesOrderDetailPopUp from '@/components/SalesOrderDetailPopUp.vue'
import { debounce } from 'lodash';

export default {
  name: 'WhiteGlove',
  components: { Vue3EasyDataTable, PurchaseOrderDetailPopUp, SalesOrderDetailPopUp },
  data() {
    return {
      open_white_glove_headers: [
        { text: "Sales Order Number", value: "sales_order_number", sortable: true },
        { text: "Stage", value: "stage", sortable: true },
        { text: "Customer", value: "customer_name", sortable: true },
        { text: "Sales Order Date", value: "order_date_sortable", sortable: true },
        { text: "White Glove Description", value: "white_glove_support_description", sortable: true },
        { text: "Complete Order Status", value: "complete_order_status", sortable: true },
        { text: "Sales Order Internal Notes", value: "internal_notes", sortable: false },
        { text: "Emails for WG Orders", value: "wg_customers_emails_for_updates", sortable: false },
        { text: "Emails For WG Address", value: "wg_customer_email_addresses_for_tracking", sortable: false },
      ],
      recently_completed_white_glove_headers: [
        { text: "Sales Order Number", value: "sales_order_number", sortable: true },
        { text: "Customer", value: "customer_name", sortable: true },
        { text: "Sales Order Date", value: "order_date_sortable", sortable: true },
        { text: "Completed Date", value: "completed_date_sortable", sortable: true },
        { text: "White Glove Description", value: "white_glove_support_description", sortable: true },
        { text: "Complete Order Status", value: "complete_order_status", sortable: true },
        { text: "Sales Order Internal Notes", value: "internal_notes", sortable: false },
        { text: "Emails for WG Orders", value: "wg_customers_emails_for_updates", sortable: false },
        { text: "Emails For WG Address", value: "wg_customer_email_addresses_for_tracking", sortable: false },
      ],
      searchOpenWhiteGlove: '',
      searchCompletedWhiteGlove: '',
      po_detail: false,
      sales_order_detail: false,
      po_for_component: null,
      sales_order_for_component: null,
      table_height: 200
    }
  },
  beforeMount() {
    if (this.user === 'vendor' || !this.user) {
      this.$router.push('/')
    }
    this.table_height = 400
  },
  created() {
    this.updateNeedsAttentionInterval = setInterval(() => {
      this.refreshKey++
    }, 60000)
    window.addEventListener("resize", this.sizeTable)
  },
  destroyed() {
    window.removeEventListener("resize", this.sizeTable)
  },
  computed: {
    ...mapGetters(['user', 'db']),
    sales_order_data() {
      const module_data = {
        open: [],
        recently_completed: [],
        open_shipments: [],
        recently_closed_shipments: []
      }
      const sales_orders = JSON.parse(JSON.stringify(this.db.sales_orders))
      const sevenDaysAgo = Date.now() - 7 * 24 * 60 * 60 * 1000
      const tenDaysAgo = Date.now() - 10 * 24 * 60 * 60 * 1000
      
      for (const so in sales_orders) {
        const order = sales_orders[so]
        order.db_key = so
        order.order_date_sortable = Moment(order.sales_order_date).startOf('day')
        order.order_date_formatted = this.formatDate(order.order_date_sortable)
        order.ship_date_sortable = order.ship_date ? Moment(order.ship_date).startOf('day') : 999
        order.ship_date_formatted = order.ship_date ? this.formatDate(order.ship_date_sortable) : ''
        order.has_shipping_data = (order.shipping_company && order.shipping_company.trim()) || (order.tracking_number && order.tracking_number.trim())
        order.sales_order_eta_sortable = order.eta ? Moment(order.eta).startOf('day') : 999
        order.sales_order_eta_formatted = order.eta ? this.formatDate(order.sales_order_eta_sortable) : ''
        order.group_shipment_id_sortable = this.normalizeForSorting(order.group_shipment_id)
        order.status = order.custom_shipping_status || (order.ship_date ? 'In Transit' : 'Not Yet Shipped')
        order.stage = order.stage ? parseFloat(order.stage) : false
        order.internal_notes_flat = order.internal_notes
          ? Object.values(order.internal_notes)
              .map(n => `${n.note ?? ''} ${n.submitted_by_name ?? ''}`)
              .join(' ')
          : '';


        if (order.has_shipping_data && order.status !== 'Complete') module_data.open_shipments.push(order)
        if (order.status === 'Complete' && order.shipping_status_complete_timestamp >= tenDaysAgo) {
          order.shipping_status_complete_timestamp_sortable = Moment(order.shipping_status_complete_timestamp).startOf('day')
          order.shipping_status_complete_timestamp_formatted = this.formatDate(order.shipping_status_complete_timestamp_sortable)
          module_data.recently_closed_shipments.push(order)
        }

        if (order.white_glove_support_order) {
          if (order.open && this.$store.state.stageFilter.includes(order.stage)){
            module_data.open.push(order)
          }
          if (!order.open && order.completed_date >= sevenDaysAgo) {
            order.completed_date_sortable = Moment(order.completed_date).startOf('day')

            order.completed_date_formatted = this.formatDate(order.completed_date_sortable)
            module_data.recently_completed.push(order)
          }
        }
      }

      return module_data
    }
  },
  methods: {
    debouncedOpenWhiteGloveSearch: debounce(function(event) {
      this.searchOpenWhiteGlove = event.target._value.replace(/\*/g, "");
    }, 500),
    debouncedCompletedWhiteGloveSearch: debounce(function(event) {
      this.searchCompletedWhiteGlove = event.target._value.replace(/\*/g, "");
    }, 500),
    updateStage(so_db_key,stage){
      var valueToSet = (stage === 'unstage') ? false : stage;   
      firebase.database().ref('sales_orders').child(so_db_key).child('stage').set(valueToSet)
    },
    normalizeForSorting(value) {
      if (!value) return "ZZZZZZ"
      const match = value.match(/^(\d+)(.*)$/)
      if (!match) return value
      const numPart = match[1].padStart(10, "0")
      const suffix = match[2] || ""
      return `${numPart}${suffix}`
    },
    openPurchaseOrderDetailPopup(po) {
      this.po_for_component = po
      this.po_detail = true
    },
    closePurchaseOrderDetailPopup() {
      this.po_for_component = null
      this.po_detail = false
    },
    openSalesOrderDetailPopup(order) {
      this.sales_order_for_component = order
      this.sales_order_detail = true
    },
    closeSalesOrderDetailPopup() {
      this.sales_order_for_component = null
      this.sales_order_detail = false
    },
    sizeTable() {
      this.table_height = window.innerHeight - 260
    },
    formatDate(date) {
      return Moment(date).format('MM/DD/YY')
    }
  }
}
</script>

<style scoped>
.v-card .v-card-title {
  color: gray;
  font-size: 14px;
}

.v-card .v-card-text {
  line-height: 100%;
}

.v-card-actions {
  min-height: 0px;
  padding: 4px 0px;
}

.dashboard-link {
  color: #ff7214;
  cursor: pointer;
  font-weight: bold;
  font-size: 11px;
}

.white-glove-label {
  background: yellow;
  text-align: center;
  line-height: 150%;
  font-size: 8px;
  font-weight: bold;
  width: 65px;
  border: 1px solid black;
  border-radius: 4px;
}

.white-glove-label.light {
  background: lightyellow;
}

.stage-filter-row {
  position: absolute;
  left:12px;
  bottom: 15px;
  color: black;
}

.stage-filter-row .v-col {
  height:20px;
}

>>>.custom-checkbox .v-label {
  font-size: 0.8rem;
  padding-right:20px;
}
</style>
